<app-breadcrumb [master]="'Wyniki konkursów'" [parentName]="'Wyniki'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
<!--  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">-->
<!--      -->
<!--  </form>-->

  <div class="list-buttons"  fxLayout="row" fxLayoutAlign="end" >
    <div>
<!--      <button *ngIf="(userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"-->
<!--              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
<!--      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>-->
<!--      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->
    </div>
  </div>


  <table mat-table [dataSource]="participantsDataSource">

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.uuid]">{{element?.partner?.shortName ? element?.partner?.shortName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.uuid]">{{element?.ofwca?.fullName ? element?.ofwca?.fullName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          {{element.partner.assetsRegional?.firstName}} {{element.partner.assetsRegional?.lastName}}
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          {{element.ofwca.assetsRegional?.firstName}} {{element.ofwca?.assetsRegional?.lastName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="award">
      <th mat-header-cell *matHeaderCellDef> Nagroda </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/stan-magazynowy/szczegoly', element?.warehouseProduct?.uuid]">{{element?.warehouseProduct?.productName ? element?.warehouseProduct?.productName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Liczba </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.amount">{{element.amount}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="additional">
      <th mat-header-cell *matHeaderCellDef> Dodatkowe </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.additional">{{element.additional}}</a>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
